export enum ProjectPricingType {
    HOURLY_RATE,
    MONTHLY_RATE,
    FIXED_PRICE,
}
